import { render } from "./CompanyForm.vue?vue&type=template&id=6781fb9e&ts=true"
import script from "./CompanyForm.vue?vue&type=script&lang=ts"
export * from "./CompanyForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__